import { render, staticRenderFns } from "./TiebaEmoji.vue?vue&type=template&id=0e25cc38&"
import script from "./TiebaEmoji.vue?vue&type=script&lang=js&"
export * from "./TiebaEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports